import { render, staticRenderFns } from "./NewEditAtendimentoPage.vue?vue&type=template&id=58b27354"
import script from "./NewEditAtendimentoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAtendimentoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports